'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _events = require('events');

var _logger = require('../lib/logger');

var _logger2 = _interopRequireDefault(_logger);

var _jsonrpcDispatch = require('jsonrpc-dispatch');

var _jsonrpcDispatch2 = _interopRequireDefault(_jsonrpcDispatch);

var _uri = require('../lib/uri');

var _uri2 = _interopRequireDefault(_uri);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Application container class which represents an application frame hosting
 * an app on a 3rd party domain.
 */
var Frame = function (_EventEmitter) {
  (0, _inherits3.default)(Frame, _EventEmitter);

  function Frame(props) {
    (0, _classCallCheck3.default)(this, Frame);

    // Binds 'this' for methods called internally
    var _this = (0, _possibleConstructorReturn3.default)(this, (Frame.__proto__ || (0, _getPrototypeOf2.default)(Frame)).call(this, props));

    _this.handleProviderMessage = _this.handleProviderMessage.bind(_this);
    _this.initIframeResizer = _this.initIframeResizer.bind(_this);
    _this.send = _this.send.bind(_this);
    _this.cleanup = _this.cleanup.bind(_this);
    _this.load = _this.load.bind(_this);
    return _this;
  }

  /**
  * @param {object} container - The DOM node to append the application frame to.
  * @param {string} source - The url source of the application
  * @param {object} options - An optional parameter that contains a set of optional configs
  */


  (0, _createClass3.default)(Frame, [{
    key: 'init',
    value: function init(container, source) {
      var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
          _ref$secret = _ref.secret,
          secret = _ref$secret === undefined ? null : _ref$secret,
          _ref$resizeConfig = _ref.resizeConfig,
          resizeConfig = _ref$resizeConfig === undefined ? {} : _ref$resizeConfig,
          _ref$iframeAttrs = _ref.iframeAttrs,
          iframeAttrs = _ref$iframeAttrs === undefined ? {} : _ref$iframeAttrs;

      this.source = source;
      this.container = container;
      this.iframe = null;
      this.iframeAttrs = iframeAttrs;
      this.wrapper = null;
      this.origin = new _uri2.default(this.source).origin;
      this.secret = secret;
      this.resizeConfig = resizeConfig;

      var self = this;
      this.JSONRPC = new _jsonrpcDispatch2.default(self.send, {
        launch: function launch() {
          self.wrapper.setAttribute('data-status', 'launched');
          self.emit('xfc.launched');
          return _promise2.default.resolve();
        },
        authorized: function authorized() {
          var detail = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

          self.wrapper.setAttribute('data-status', 'authorized');
          self.emit('xfc.authorized', detail);
          self.initIframeResizer();
          return _promise2.default.resolve();
        },
        unload: function unload() {
          var detail = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

          self.wrapper.setAttribute('data-status', 'unloaded');
          self.emit('xfc.unload', detail);
          return _promise2.default.resolve();
        },
        resize: function resize() {
          var height = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
          var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

          if (typeof resizeConfig.customCalculationMethod === 'function') {
            resizeConfig.customCalculationMethod.call(self.iframe);
            return _promise2.default.resolve();
          }

          if (height) {
            self.iframe.style.height = height;
          }

          if (width) {
            self.iframe.style.width = width;
          }
          return _promise2.default.resolve();
        },
        event: function event(_event, detail) {
          self.emit(_event, detail);
          return _promise2.default.resolve();
        },
        authorizeConsumer: function authorizeConsumer() {
          return _promise2.default.resolve('hello');
        },
        challengeConsumer: function challengeConsumer() {
          return _promise2.default.resolve(self.secret);
        },
        loadPage: function loadPage(url) {
          self.load(url);
          return _promise2.default.resolve();
        }
      });
    }
  }, {
    key: 'initIframeResizer',
    value: function initIframeResizer() {
      var config = this.resizeConfig;

      // If user chooses to use fixedHeight or fixedWidth,
      // set height/width to the specified value and keep unchanged.
      if (config.fixedHeight || config.fixedWidth) {
        if (config.fixedHeight) {
          this.iframe.style.height = config.fixedHeight;
        }
        if (config.fixedWidth) {
          this.iframe.style.width = config.fixedWidth;
        }
      } else {
        // If user chooses to update iframe dynamically,
        // replace customCalculationMethod by a boolean indicator
        // in config because method is not transferrable.
        if (typeof config.customCalculationMethod === 'function') {
          config = (0, _extends3.default)({}, config);
          config.customCal = true;
          delete config.customCalculationMethod;
        }
        this.JSONRPC.notification('resize', [config]);
      }
    }

    /**
    * Mount this application onto its container and initiate resize sync.
    */

  }, {
    key: 'mount',
    value: function mount() {
      if (this.iframe) return;

      // Set up listener for all incoming communication
      window.addEventListener('message', this.handleProviderMessage);

      this.wrapper = document.createElement('div');
      this.wrapper.className = 'xfc';
      this.wrapper.setAttribute('data-status', 'mounted');
      this.container.appendChild(this.wrapper);

      var iframe = document.createElement('iframe');
      iframe.src = this.source;
      if (!this.resizeConfig.scrolling) {
        iframe.style.overflow = 'hidden';
        iframe.scrolling = 'no';
      }

      // Put custom attributes on iframe if specified
      (0, _entries2.default)(this.iframeAttrs).forEach(function (_ref2) {
        var _ref3 = (0, _slicedToArray3.default)(_ref2, 2),
            key = _ref3[0],
            value = _ref3[1];

        iframe.setAttribute(key, value);
      });

      this.iframe = iframe;
      this.wrapper.appendChild(iframe);

      this.emit('xfc.mounted');
    }

    /**
     * Unmount this application from its container
     */

  }, {
    key: 'unmount',
    value: function unmount() {
      if (this.wrapper.parentNode === this.container) {
        this.container.removeChild(this.wrapper);
        this.emit('xfc.unmounted');
        this.cleanup();
      }
    }

    /**
     * Cleans up unused message listeners and references of detached nodes
     */

  }, {
    key: 'cleanup',
    value: function cleanup() {
      // Remove listener for all incoming communication
      window.removeEventListener('message', this.handleProviderMessage);

      // Sets references of detached nodes to null to avoid potential memory leak
      this.iframe = null;
      this.wrapper = null;
    }

    /**
     * Loads a new page within existing frame.
     * @param  {string} url - the URL of new page to load.
     */

  }, {
    key: 'load',
    value: function load(url) {
      this.origin = new _uri2.default(url).origin;
      this.source = url;
      this.wrapper.setAttribute('data-status', 'mounted');
      this.iframe.src = url; // Triggers the loading of new page
    }

    /**
    * Handles an incoming message event by processing the JSONRPC request
    * @param {object} event - The emitted message event.
    */

  }, {
    key: 'handleProviderMessage',
    value: function handleProviderMessage(event) {
      // 1. This isn't a JSONRPC message or iframe is null, exit.
      if (!event.data.jsonrpc || !this.iframe) return;

      // 2. Identify the app the message came from.
      if (this.iframe.contentWindow !== event.source) return;

      // For Chrome, the origin property is in the event.originalEvent object.
      // Update origin so it can be used to post back to this frame.
      this.origin = event.origin || event.originalEvent.origin;

      _logger2.default.log('<< consumer', event.origin, event.data);

      // 3. Send a response, if any, back to the app.
      this.JSONRPC.handle(event.data);
    }

    /**
    * Post the given message to the application frame.
    * @param {object} message - The message to post.
    * See: https://developer.mozilla.org/en-US/docs/Web/API/Window/postMessage
    */

  }, {
    key: 'send',
    value: function send(message) {
      if (message) {
        _logger2.default.log('>> consumer', this.origin, message);
        this.iframe.contentWindow.postMessage(message, this.origin);
      }
    }

    /**
    * Triggers an event within the embedded application.
    * @param {string} event - The event name to trigger.
    * @param {object} detail - The data context to send with the event.
    */

  }, {
    key: 'trigger',
    value: function trigger(event, detail) {
      this.JSONRPC.notification('event', [event, detail]);
    }
  }]);
  return Frame;
}(_events.EventEmitter);

exports.default = Frame;


//////////////////
// WEBPACK FOOTER
// ./node_modules/xfc/lib/consumer/frame.js
// module id = 105
// module chunks = 0